import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {CountUpDirective} from "../../../../core/directives/count-up.dircetive";

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  imports: [
    CountUpDirective
  ],
  styleUrls: ['./statistics.component.scss']
})
export class StatisticsComponent {

  count = 200;
  duration = 5000;
  @ViewChild('element') element!: ElementRef;
  isVisible = false;

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    const titleContainerOffset = this.element.nativeElement.offsetTop;
    const scrollPosition = window.scrollY + window.innerHeight;
    scrollPosition > titleContainerOffset ? this.isVisible = true : this.isVisible = false;
  }

}
